export const primary = {
  50: "#e3edea", // lightest
  100: "#b8d0c6",
  200: "#8ab1a0",
  300: "#5c927a",
  400: "#387a5e",
  500: "#174f42", // base color
  600: "#14463b",
  700: "#103c32",
  800: "#0c3229",
  900: "#061f1a", // darkest
};
